var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnhideButtonIcon = function SvgUnhideButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "second-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.004 0C3.48 0 .073 7.675.073 7.675a.8.8 0 0 0 0 .65S3.476 16 12.004 16s11.931-7.675 11.931-7.675a.8.8 0 0 0 0-.65S20.524 0 12.004 0Zm0 1.6c6.482 0 9.594 5.055 10.307 6.4-.713 1.345-3.824 6.4-10.307 6.4S2.404 9.345 1.693 8c.711-1.345 3.824-6.4 10.311-6.4Zm0 1.6a4.8 4.8 0 1 0 4.8 4.8 4.8 4.8 0 0 0-4.8-4.8Zm0 1.6a3.2 3.2 0 1 1-3.2 3.2 3.2 3.2 0 0 1 3.2-3.2Z",
    fillRule: "evenodd"
  })));
};
export default SvgUnhideButtonIcon;